// app/javascript/controllers/stocks_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stockableFields"]

  stockableTypeChanged(event) {
    const stockableType = event.target.value
    const url = `/stocks/stockable_fields?type=${stockableType}`

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'text/html'
      }
    })
      .then(response => response.text())
      .then(html => {
        this.stockableFieldsTarget.innerHTML = html
      })
  }
}